import { useCallback, useContext } from 'react';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-pro';
import { Tooltip } from '@mui/material';
import { SelectDateTime } from '../selectDateTime';
import { GridRowContext } from './PhoenixGrid';

interface IGridColDateTimeProps {
  params: GridRenderEditCellParams;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (event: any) => void; 
  disabled?: boolean;
}

export const GridColDateTime = ({ params, onChange}: IGridColDateTimeProps) => {
  const api = useGridApiContext();
  const rowContext = useContext(GridRowContext);

  const { id, field, value = '' } = params;

  const handleChange = useCallback(
    (value: string | null) => {
      if (rowContext.errors[field]) {
        rowContext.resetError(field);
      }

      api.current.setEditCellValue({ id, field, value });
      onChange?.({ value, name: field });
    },
    [api, id, field, onChange, rowContext.errors, rowContext.resetError]
  );

  return (
    <Tooltip title={rowContext.errors[field]}>
        <SelectDateTime
          label=""
          value={value}
          onChange={handleChange}
        />
    </Tooltip>
  );
};
